import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram, FaYoutube } from 'react-icons/fa';
import { Button } from './Button';
import '../../css/general/FooterV2.css';

interface IFooterV2Props {
    isLoggedIn: boolean;
    onContactClick: () => void;
    onFeedbackClick: () => void;
}

function FooterV2({ isLoggedIn, onContactClick, onFeedbackClick }: IFooterV2Props) {
    const currentYear = new Date().getFullYear();
    const [email, setEmail] = useState('');

    const handleNewsletterSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        // TODO: Implement newsletter subscription
        console.log('Newsletter subscription:', email);
        setEmail('');
    };

    return (
        <footer className="footer-v2">
            <div className="footer-v2-container">
                {/* Main Footer Content */}
                <div className="footer-v2-main">
                    {/* Company Info */}
                    <div className="footer-v2-section footer-company">
                        <h3 className="footer-v2-title">Lostine Drone Co.</h3>
                        <p className="footer-company-description">
                            Professional drone services delivering innovative aerial solutions
                            for real estate, construction, and commercial projects.
                        </p>
                        <div className="footer-certifications">
                            <span className="certification-badge">
                                <i className="fa-solid fa-certificate"></i>
                                FAA Part 107 Licensed
                            </span>
                            <span className="certification-badge">
                                <i className="fa-solid fa-shield-halved"></i>
                                $1M Insured
                            </span>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div className="footer-v2-section footer-links">
                        <h4 className="footer-v2-subtitle">Quick Links</h4>
                        <ul className="footer-links-list">
                            <li><Link to="/services">Services</Link></li>
                            <li><Link to="/about">About Us</Link></li>
                            <li><a href="#" onClick={(e) => { e.preventDefault(); onContactClick(); }}>Contact</a></li>
                        </ul>
                    </div>

                    {/* Legal Links */}
                    <div className="footer-v2-section footer-legal">
                        <h4 className="footer-v2-subtitle">Legal</h4>
                        <ul className="footer-links-list">
                            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                            <li><Link to="/terms-of-service">Terms of Service</Link></li>
                            <li><a href="https://form.jotform.com/243178125183052" target="_blank" rel="noreferrer">Request Refund</a></li>
                            {isLoggedIn && <li><Link to="/settings">Account Settings</Link></li>}
                        </ul>
                    </div>

                    {/* Contact & Newsletter */}
                    <div className="footer-v2-section footer-contact">
                        <h4 className="footer-v2-subtitle">Stay Connected</h4>
                        <div className="footer-contact-info">
                            <a href="tel:314-964-6438" className="footer-contact-item">
                                <i className="fa-solid fa-phone"></i>
                                <span>(314) 964-6438</span>
                            </a>
                            <a href="mailto:brenton.atchison@lostinedrone.com" className="footer-contact-item">
                                <i className="fa-solid fa-envelope"></i>
                                <span>brenton.atchison@lostinedrone.com</span>
                            </a>
                            <div className="footer-contact-item">
                                <i className="fa-solid fa-location-dot"></i>
                                <span>12645 Olive Blvd, 2nd Floor<br />St. Louis, MO 63141</span>
                            </div>
                        </div>

                        {/* Newsletter Signup - hidden for now */}
                    </div>
                </div>

                {/* Action Buttons */}
                <div className="footer-v2-actions">
                    <Button
                        props={{
                            text: "Contact Us",
                            onClick: onContactClick,
                            classes: 'footer-action-btn'
                        }}
                    />
                    {isLoggedIn && (
                        <Button
                            props={{
                                text: "Give Feedback",
                                onClick: onFeedbackClick,
                                classes: 'footer-action-btn'
                            }}
                        />
                    )}
                </div>

                {/* Social Media */}
                <div className="footer-v2-social">
                    <h4 className="footer-v2-subtitle">Follow Us</h4>
                    <div className="social-links">
                        <a href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook">
                            <FaFacebook />
                        </a>
                        <a href="https://twitter.com" target="_blank" rel="noreferrer" aria-label="Twitter">
                            <FaTwitter />
                        </a>
                        <a href="https://linkedin.com" target="_blank" rel="noreferrer" aria-label="LinkedIn">
                            <FaLinkedin />
                        </a>
                        <a href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram">
                            <FaInstagram />
                        </a>
                        <a href="https://youtube.com" target="_blank" rel="noreferrer" aria-label="YouTube">
                            <FaYoutube />
                        </a>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="footer-v2-bottom">
                    <p className="footer-copyright">
                        © {currentYear} Lostine Drone Co. All rights reserved.
                    </p>
                    <p className="footer-tagline">
                        Elevating perspectives, one flight at a time.
                    </p>
                </div>
            </div>
        </footer>
    );
}

export default FooterV2;
